import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import apiClient from "../../api/apiClient"
import { API_ENDPOINTS } from "../../constants/apiEndpoints"
import { toast } from "react-hot-toast"

// Initial state
const initialState = {
  order: null,
  loading: false,
  error: null,
  success: false,
}

// Create order async thunk
export const createOrder = createAsyncThunk("order/createOrder", async (orderData, { rejectWithValue, getState }) => {
  try {
    // Check if cart has items
    const cartItems = getState().cart.items
    if (!cartItems || cartItems.length === 0) {
      toast.error("Your cart is empty. Please add items to your cart before placing an order.")
      return rejectWithValue("Cart is empty")
    }

    // Simplify the payload to only include paymentMethod and shippingAddress
    const payload = {
      paymentMethod: orderData.paymentMethod,
      shippingAddress: orderData.shippingAddress,
    }

    const response = await apiClient.post(API_ENDPOINTS.CREATE_ORDER, payload);
    console.log("✅ API Response:", response.data); // ← Add this line
    toast.success("Order placed successfully!")
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.message || "Failed to create order"
    toast.error(errorMessage)
    return rejectWithValue(errorMessage)
  }
})

// Order slice
const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    resetOrderState: (state) => {
      state.order = null
      state.loading = false
      state.error = null
      state.success = false
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createOrder.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = false
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        state.loading = false
        state.order = action.payload
        state.success = true
      })
      .addCase(createOrder.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
        state.success = false
      })
  },
})

// Export actions and reducer
export const { resetOrderState } = orderSlice.actions
export default orderSlice.reducer

// Selectors - Fix these to properly access the state
export const selectOrder = (state) => state.order?.order
export const selectOrderLoading = (state) => state.order?.loading
export const selectOrderError = (state) => state.order?.error
export const selectOrderSuccess = (state) => state.order?.success
